import { Attribute } from "../model/Feature";
import AggregateFilterControl from "./filter/AggregateFilterControl";
import AndFilterControl from "./filter/AndFilterControl";
import CheckboxFilterControl from "./filter/CheckboxFilterControl";
import DateFilterControl from "./filter/DateFilterControl";
import DropdownFilterControl from "./filter/DropdownFilterControl";
import InScheduleFilterControl from "./filter/InScheduleFilterControl";
import InteractsFilterControl from "./filter/InteractsFilterControl";
import NearestFilterControl from "./filter/NearestFilterControl";
import NumericFilterControl from "./filter/NumericFilterControl";
import OrFilterControl from "./filter/OrFilterControl";
import TerritoryLevelFilterControl from "./filter/TerritoryLevelFilterControl";
import WithinDistanceFilterControl from "./filter/WithinDistanceFilterControl";

import type LayerViewModel from "../map/LayerViewModel";
import type { Criteria } from "../model/Criteria";
import type FormatterFuncs from "../util/formatterFuncs";
import type AbstractFilterControl from "./filter/AbstractFilterControl";

type FilterControlClassRef = {
    new (...args: any[]): AbstractFilterControl
};

const FILTER_CLASSES: FilterControlClassRef[] = [
    AggregateFilterControl,
    AndFilterControl,
    CheckboxFilterControl,
    DateFilterControl,
    DropdownFilterControl,
    InScheduleFilterControl,
    InteractsFilterControl,
    NearestFilterControl,
    NumericFilterControl,
    OrFilterControl,
    TerritoryLevelFilterControl,
    WithinDistanceFilterControl
];

export default class FilterControlFactory {
    static fromCriteria(layerViewModel: LayerViewModel, criteria: Criteria, attributes, range, layerModule, analysis, formatterFuncs: FormatterFuncs): AbstractFilterControl | JQueryDeferred<AbstractFilterControl> | undefined {
        if ((criteria.$type === "Or" || criteria.$type  === "And") && criteria.criteria.length === 1) {
            criteria = criteria.criteria[0];
        }

        const filterClass = this.forCriteria(criteria, attributes, range, layerViewModel);
        if (filterClass) {
            // @ts-ignore fromCriteria is a static method, can't add static to interface but it will be there...
            return filterClass.fromCriteria(layerViewModel, criteria, attributes, range, layerModule, analysis, formatterFuncs);
        }

        console.error("Unsupported criteria: ", criteria);
        return es.util.deferred.rejected("Could not create filter");
    }

    static forCriteria(criteria: Criteria, attributes: Attribute[], range, layerViewModel: LayerViewModel): FilterControlClassRef | undefined {
        return FILTER_CLASSES.find((child) => {
            // @ts-ignore supportCriteria is a static method, can't add static to interface but it will be there...
            return child.supportCriteria(criteria, attributes, range, layerViewModel);
        });
    }

    static forAttribute(attrType: string, range): FilterControlClassRef | undefined {
        return FILTER_CLASSES.find((child) => {
            // @ts-ignore supportAttribute is a static method, can't add static to interface but it will be there...
            return child.supportAttribute(attrType, range);
        });
    };
}